exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vselect[data-v-3240bdda]{background:#fff;border-radius:20px;margin-right:15px;-webkit-box-shadow:0 2px 8px rgba(15,23,65,.08);box-shadow:0 2px 8px rgba(15,23,65,.08)}.vselect .vselect-title[data-v-3240bdda]{display:block}.vselect[data-v-3240bdda] .el-select .el-input__inner{border:1px solid transparent;margin-left:-5px}.vselect .btn[data-v-3240bdda]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3240bdda","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Vselect/index.vue
// module id = VWuu
// module chunks = 5